import DATATABLE_TRANSLATIONS from "./datatable_translations";
export default class CapabilitiesDataTable {
  constructor() {
    $(document).ready(function() {
      showCapabilitiesTable();
    });

    $(document).on("turbo:render", function() {
      showCapabilitiesTable();
    });

    function showCapabilitiesTable() {
      $('#capabilities-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#capabilities-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "active"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
